module.exports = __webpack_public_path__ + "img/pres-01.b710d768.png";